import { QUERY_KEYS } from 'api/query-keys';
import { bankAccountService } from 'hq/services';
import { useInfiniteQuery } from 'react-query';
import { DEFAULT_PAGE_SIZE } from 'shared/utils/constants';

export const useGetPendingBankAccounts = () => {
  return useInfiniteQuery({
    queryKey: QUERY_KEYS.flexWorkerBankAccounts(),
    queryFn: async ({ pageParam = 0 }) =>
      await bankAccountService.getPendingBankAccounts({
        page: pageParam,
        pageSize: DEFAULT_PAGE_SIZE,
      }),
    getNextPageParam: (lastPage) => lastPage.nextPage,
  });
};
